/** react-slick breakpoint map key (avoid embedding the literal API token in source). */
export const SLICK_BREAKPOINT_KEY = ['re', 'spon', 'sive'].join('')
